// 单文件引入方式

import UserPicker from './ZuiUserPicker.vue'

export default {
  install(Vue) {
    Vue.component('ZuiUserPicker', UserPicker)
  }
}

export { UserPicker }
